import type {FC} from 'react';
import {memo} from 'react';

import DownloadsIconSVG from '@yourcoach/shared/assets/icons/downloads.svg';

interface Props {
  customClass?: string;
  height?: string;
  width?: string;
}

const DownloadsIcon: FC<Props> = ({
  customClass = '',
  height = '100%',
  width = '100%',
}) => {
  return (
    <DownloadsIconSVG
      className={`${customClass}`}
      fill="#ffffff73"
      height={width}
      width={height}
    />
  );
};

export default memo(DownloadsIcon);
